<script>
  export let mt = 0
  export let mr = 0
  export let mb = 0
  export let ml = 0
</script>

<div class="buttonGroup" style="margin:{mt}rem {mr}rem {mb}rem {ml}rem">
  <slot/>
</div>

<style>
  :global(.buttonGroup > [role=button] + [role=button]) { 
    margin-left: 1rem;
  }
</style>